/**
* @name: AppSearch
* @author: weiyong
* @date: 2023-09-21 00:14
* @description：AppSearch
* @update: 2023-09-21 00:14
*/
<template>
  <div class="AppDownImg">
    <div @click="showAppDown" class="AppDownImg-text" :style="getTechnologyFrameTextColor" v-if="isFrameType">{{ t('layout.header.downloadApp') }}</div>
    <a-tooltip v-else >
      <template #title>{{t('app下载')}}</template>
      <span role="img" @click="showAppDown" >
        <span class="remix-icon ri-erweima"></span>
      </span>
    </a-tooltip>

    <a-modal
      v-model:visible="appDownFlag"
      :width="600"
      class="create-app-modal-win"
      :title="t('app安装二维码')"
      :footer="null"
      :maskClosable="false"
    >
      <div  style="height:450px;padding:20px;">
        <div class="flex-div h100b" style="height:calc(100% - 80px);justify-content: center;align-items: center;">
          <a-image
            :width="200"
            :src="androidDownUrlVal"
          />
        </div>

        <div style="position: absolute;bottom:50px;padding:0 20px 0 0;color:#F42535">
          注：尊敬的用户，感谢支持，安卓用户请用手机浏览器扫码下载！如果遇到软件使用问题，请将意见反馈给我们，谢谢！
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "AppDownImg",
});
</script>

<script lang="ts" setup>
import {Tooltip as ATooltip,Modal as AModal,Image as AImage} from "ant-design-vue";
import {useI18n} from "@/hooks/web/useI18n";
import {loadCurSystemConfig} from "@/utils/CurSystemConfigUtils";
import { useAppFrame } from '@/hooks/useAppFrame';
const { isFrameType,getTechnologyFrameTextColor } = useAppFrame();
const { t } = useI18n();

const appDownFlag=ref(false)
const showAppDown=function (){
  appDownFlag.value=true;
}

const androidDownUrlVal=ref('');
loadCurSystemConfig((sysConfigJson)=>{
  const {androidDownUrl}=sysConfigJson;
  androidDownUrlVal.value=androidDownUrl;
})
</script>

<style type="text/css" lang="less">
.AppDownImg{
  cursor:pointer;
  &-text {
    font-size: 14px;
    color: #FFF;
  }
}
</style>
